import { Box, Typography } from "@mui/material"
import { NoDataFound } from "../../../../empty/Index"

export const Tbody = ({ salesBranchList, generateForm }) => {

    return (
        <Box
            height="100%"
            overflowY="auto"
            width="100%"
            bgcolor="#FFFFFF"
            borderRadius="12px"
            className="overflowY"
            display="flex"
            flexDirection="column"
            gap="12px"
            p={2}
        >
            {(!generateForm.infiniteLoad && salesBranchList.length === 0) && (
                <Box sx={{ height: "100%" }}>
                    <NoDataFound />
                </Box>
            )}

            {(!generateForm.infiniteLoad && salesBranchList.length > 0) &&
                salesBranchList.map((v, k) => (
                    <Box
                        key={k}
                        sx={{
                            p: 2,
                            borderRadius: "12px",
                            boxShadow: "0px 2px 8px rgba(0,0,0,0.05)",
                            border: 1,
                            borderColor: "#c9c9c9ff"
                        }}
                    >
                        {/* Branch */}
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Box fontSize={12}>Branch:</Box>
                            <Typography fontSize={13} fontWeight={500}>
                                {v.name}
                            </Typography>
                        </Box>

                        {/* User */}
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Box fontSize={12}>User:</Box>
                            <Typography fontSize={13} fontWeight={500}>
                                {v.first_name} {v.last_name}
                            </Typography>
                        </Box>

                        {/* Date */}
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Box fontSize={12}>Date:</Box>
                            <Typography fontSize={13}>
                                {v.date}
                            </Typography>
                        </Box>

                        {/* Total Sales */}
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Box fontSize={12}>Total Sales:</Box>
                            <Typography fontSize={13} fontWeight={600}>
                                ₱ {parseFloat(v.total_sales).toLocaleString('en-PH', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}
                            </Typography>
                        </Box>

                        {/* Actual Sales */}
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Box fontSize={12}>Actual Sales:</Box>
                            <Typography fontSize={13} fontWeight={500}>
                                ₱ {parseFloat(v.actual_sales).toLocaleString('en-PH', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}
                            </Typography>
                        </Box>

                        {/* Reconciled Sales */}
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Box fontSize={12}>Reconciled:</Box>
                            <Typography fontSize={13}>
                                ₱ {parseFloat(!!v.reconciled_sales ? v.reconciled_sales : 0).toLocaleString('en-PH', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}
                            </Typography>
                        </Box>

                        {/* Variance */}
                        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                            <Box fontSize={12}>Variance:</Box>
                            <Typography fontSize={13} fontWeight={600} color="primary.main">
                                ₱ {parseFloat(
                                    !!v.reconciled_sales ? v.recon_variance : v.variance
                                ).toLocaleString('en-PH', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}
                            </Typography>
                        </Box>
                    </Box>
                ))}
        </Box>
    )
}